import React from 'react';
import { Divider, Text } from '@chakra-ui/react';
import Card from '#coreComponents/Card';
import Heading from '#coreComponents/Heading';
import { FormData } from './SdgQuiz';
import { QuestionFormItemSelect } from './QuestionFormItemSelect';
import contentJson from '../utils/content.json';
import { useResponsive } from '#core/SdgQuiz/utils';

const content: any = contentJson;

type QuestionFormItemProps = {
  sdgNumber: number;
  sdgType: string;
  data: any;

  updateFields: (fields: Partial<FormData>) => void;
};

export const QuestionFormItem = ({
  sdgNumber,
  sdgType,
  data,
  updateFields,
}: QuestionFormItemProps) => {
  const currentContent = content?.questionTypeData[sdgType];

  const questions = content[`sdg${sdgNumber}`].questions[sdgType];

  const isMobileScreen = useResponsive();

  return (
    <Card px={7} my={3}>
      <Heading as="h2" size="md" fontSize={isMobileScreen ? 'lg' : '3xl'}>
        {currentContent?.title}
      </Heading>

      <Text fontSize={isMobileScreen ? 'md' : 'lg'} color="gray.500">
        {currentContent?.content}
      </Text>

      <Divider opacity={1} my={5} />

      {questions.map(
        (question: { title: string; content: string }, idx: number) => {
          const key = `sdg${sdgNumber}_${sdgType}_${idx + 1}`;
          return (
            <QuestionFormItemSelect
              value={data[key]}
              key={key}
              fieldName={key}
              updateFields={updateFields}
              title={question.title}
            />
          );
        },
      )}
    </Card>
  );
};
